import LinearProgress from "@material-ui/core/LinearProgress";

const LoadingPage = () => {
  return <LinearProgress />;
};

export default LoadingPage;
